import moment from 'moment/moment'

import { DataType } from '../types/DataType'
import { ConstructorArgs } from '../types/models'
import { BaseRecord } from './BaseRecord'
import { Goal } from './Goal'
import { FKType } from './SQLBuilder'
import { User } from './User'

type BadgeConstructorArgs = ConstructorArgs<() => Badge>

export class Badge extends BaseRecord {
    readonly recordType = 'badge'

    readonly lastModifiedDate: moment.Moment | undefined

    constructor(data?: Partial<BadgeConstructorArgs>) {
        super(data)
        if (!data) {
            return
        }

        this.lastModifiedDate = this.propertyFromTimestampArg(data.last_modified_date)
    }

    clone(overrides?: Partial<BadgeConstructorArgs>): Badge {
        return new Badge({ ...this.serializeForClone(), ...overrides })
    }

    static fk: FKType = {
        goals: ['goal'],
        users: ['owner'],
    }

    static dataType(): DataType {
        return 'badges'
    }

    get goal(): Goal | undefined {
        return this.getForeignRecord('goal', Goal)
    }
    set goal(goal: Goal | undefined) {
        this.setForeignRecord('goal', goal)
    }
    get owner(): User | undefined {
        return this.getForeignRecord('owner', User)
    }
    set owner(owner: User | undefined) {
        this.setForeignRecord('owner', owner)
    }
}
